import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import { Spinner } from '../../components';
import { getDigitalLetterForExternalUser } from '../../../config/redux/actions/bank';

import DigitalLetterComposeExternal from './DigitalLetterComposeExternal';
import notapLogo from '../../../assets/images/notap_logo.png';

const schema = z.object({
    passcode: z.string().length(8, "Authorization Code must be exactly 8 characters"),
});

const DigitalLetterExternalResponse = () => {
    const { reference } = useParams();

    const { externalUser } = useSelector((state) => state.bankUser);
    const { formState, register, handleSubmit } = useForm({
        resolver: zodResolver(schema),
        mode: 'onChange'
    });

    const dispatch = useDispatch();

    const onSubmitPasscode = async ({ passcode }) => {
        await dispatch(getDigitalLetterForExternalUser({ 
            reference,
            passcode 
        }));
    };

    if (externalUser.letterDetails) {
        return <DigitalLetterComposeExternal />
    }

    return (
        <div className='d-flex justify-content-center align-items-baseline profile-creation'>
            <div className='mt-5 card card-default pt-5 px-5 pb-0'>
                <div className='formContainer'>
                    <div style={{columnGap: '1rem'}} className='d-flex align-items-center justify-content-center'>
                        <img src={notapLogo} alt='logo' className='logotypeImage' />
                        <h2 className='font-weight-bold'>
                            NOTAP Portal
                        </h2>              
                    </div>

                    <div style={{columnGap: '0.8rem'}} className='greeting d-flex justify-content-center align-items-center'>
                        <p style={{fontSize: '1.3rem'}} className='text-capitalize'>
                            Enter Your Authorization Code
                        </p>
                    </div>

                    <form className='mainForm' onSubmit={handleSubmit(onSubmitPasscode)}>
                        <div className="row w-100 m-0">
                            {externalUser.errorMessage && (
                                <div className="mb-4 w-100">
                                    <div className="alert alert-danger" role="alert">
                                        {externalUser.errorMessage}
                                    </div>
                                </div>
                            )}

                            <div className="form-group col-md-12 mb-4">
                                <label htmlFor='otp'>
                                    Authorization Code:
                                </label>

                                <input 
                                    type="text" 
                                    className="form-control input-lg" 
                                    {...register("passcode")}
                                />

                                {formState.errors.passcode && (
                                    <div className="text-danger small mt-1">
                                        {formState.errors.passcode.message}
                                    </div>
                                )}
                            </div>  
       
                            <div className="col-md-12">
                                <div>
                                    {externalUser.isFetching 
                                        ? <Spinner /> 
                                        : <button type="submit" className="btn btn-primary mb-4">Submit</button>}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>        
            </div>        
        </div>
    );
};

export default DigitalLetterExternalResponse;